"use strict";

define('uikit/elements/input',['underscore', 'marionette', '../channel', '../mixins/component.mixin', './button', '../templates', '../extra/size', 'autosize'], function (_, Mn, channel, ComponentMixin, ButtonView, Templates, Size, autosize) {
  var Input = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui input',
    template: Templates.UIKit['input'],
    events: {
      'keydown input,textarea': function keydown_inputTextarea(ev) {
        var self = this;
        _.defer(function () {
          self.triggerMethod('before:key:code', ev.keyCode || ev.which);
          self._internal.value = self.ui.input.val();
          self.triggerMethod('key:code', ev.keyCode || ev.which);
        });
      },
      'paste input,textarea': function paste_inputTextarea(ev) {
        var self = this;
        _.defer(function () {
          self._internal.value = self.ui.input.val();
        });
      },
      'input input,textarea': function input_inputTextarea(ev) {
        var self = this;
        _.defer(function () {
          self._internal.value = self.ui.input.val();
        });
      }
    },
    triggers: {
      'focus input, textarea': {
        preventDefault: false,
        event: 'focus'
      },
      'blur input, textarea': 'blur'
    },
    ui: {
      input: 'input, textarea'
    },
    internalViews: {
      'button': ButtonView
    },
    options: {
      visible: true,
      inputType: 'text',
      inputAutocomplete: false,
      value: '',
      placeholder: '',
      icon: null,
      iconRight: false,
      error: false,
      loading: false,
      label: null,
      labelRight: false,
      transparent: false,
      size: '',
      focusable: true,
      readonly: false,
      fluid: false,
      buttonRight: true,
      button: null,
      disabled: false,
      rowCount: 1,
      multiLine: false
    },
    inputTypeOptionValues: ['text', 'password'],
    sizeOptionValues: _.values(Size),
    update: {
      visible: false,
      value: false,
      readonly: false,
      loading: false
    },
    bindings: {},
    focus: function focus() {
      if (!_.isEmpty(this.ui.input)) {
        this.ui.input.focus();
      }
      return this;
    },
    onRender: function onRender() {
      var self = this;
      if (this.multiLine) {
        _.defer(function () {
          autosize(self.ui.input);
        });
      }
    },
    onFirstRender: function onFirstRender() {
      var self = this;
      this.vent.on('change:value', function () {
        self.ui.input.val(self.value);
      });
      this.on('change:visible', function () {
        if (this.visible && this.multiLine && this.autosize) {
          _.defer(function () {
            autosize.update(self.ui.input);
          });
        }
      });
      this.ui.input.val(this.value);
    },
    updateAttributes: function updateAttributes() {
      var iconLeft = !this.getBoolOption('iconRight') && (this.getBoolOption('buttonRight') || !this.getOption('button')),
        button = this.button;
      this.addClass(this.getOption('size'), this.getBoolOption('size')).addClass('transparent', this.getBoolOption('transparent')).addClass('left', iconLeft && this.getBoolOption('icon')).addClass('icon', this.getBoolOption('icon')).addClass('loading', this.getBoolOption('loading')).addClass('error', this.getBoolOption('error')).addClass('right', this.getBoolOption('labelRight') && this.getBoolOption('label')).addClass('labeled', this.getBoolOption('label')).addClass('fluid', this.getBoolOption('fluid')).addClass('disabled', this.getBoolOption('disabled'));
      if (!iconLeft) {
        this.addClass('left', !this.getBoolOption('buttonRight'));
      }
      this.ui.input.prop('readonly', this.readonly);
      this.ui.input.prop('disabled', this.getBoolOption('disabled'));
      this.addClass('action', button && button.visible);
      if (this.multiLine) {
        autosize.update(this.ui.input);
      }
    },
    onKeyCode: function onKeyCode(code) {
      switch (code) {
        case 13:
          if (!this.multiLine) {
            this.triggerMethod('enter');
          }
          break;
        case 27:
          this.triggerMethod('escape');
          break;
      }
    }
  });
  channel.reply('input', function () {
    return Input;
  });
  return Input;
});

